<template>
    <v-card elevation="1" style="border-radius: 0;">
        <v-card-title test-tag="tag-133"><T>Время</T></v-card-title>
        <v-divider></v-divider>
        <v-layout v-if="!loading">
            <TimeInput v-model="hours" :min="min_hours" :max="max.hour" :count="23"/>
            <TimeInput v-model="minutes" :step="step" :min="min_minutes" :max="max_minutes" :count="59"/>
        </v-layout>
    </v-card>
</template>

<script>
import TimeInput from '@/components/common/TimeInput'

export default{
    props:{
        value: [Date, Object],
        min: {
            type: Object,
            default(){
                return {
                    hour: 0,
                    minute: 0 
                }
            }
        },
        max:{
            type: Object,
            default(){
                return{
                    hour: 23,
                    minute: 59
                }
            }
        },
        step:{
            type: Number,
            default: 10
        }
    },
    data: () => ({
        min_minute: null,
        max_minute: null,
        min_hour: null,
        loading: null
    }),
    computed:{
        min_hours:{
            get(){
                return this.min.hour
            },
            set(v){
                this.min_hour = v
            }
        },

        min_minutes:{
            get(){
                return this.min_minute
            },
            set(v){
                this.min_minute = v
            }
        },

        max_minutes:{
            get(){
                return this.max_minute
            },
            set(v){
                this.max_minute = v
            }
        },

        minutes:{
            get(){
                return this.value.minute
            },
            set(v){
                let time = this.value.set({hour: this.hours, minute: v})
                this.$emit('input', time)
            }
        },

        hours:{
            get(){
                return this.value.hour
            },
            set(v){
                 let time = this.value.set({hour: v, minute: this.minutes})
                this.$emit('input', time)
            }
        },
    },  
    methods:{
        range(val){
            if(val == this.min.hour){
                let time = Math.ceil(this.min.minute/this.step)*this.step 
                if(time >= 60){
                    this.min_minutes = time-60
                    this.min_hours=this.min.hour+1
                }else{
                    this.min_minutes=time
                    this.min_hours=this.min.hour
                }
                this.max_minutes = 59
            }
            else if(val == this.max.hour){
                this.max_minutes = this.max.minute
                this.min_minutes = 0 
            }
            else{
                this.min_minutes = 0
                this.max_minutes = 59
            }
        },
    },
    mounted(){
        this.loading=true
        this.range(this.hours)
        this.loading=false
    },
    watch:{
        hours(val){
            this.range(val)
        },
        value(){
            this.$emit('picked')
        }
    },
    components:{
        TimeInput
    }
}
</script>

<style scoped>

</style>